// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  maintenance: false,
  logging: true,
  firebase: {
    apiKey: 'AIzaSyBrg_TqfHZHIGgcSAe-kX4GWEX4TjNBbCc',
    authDomain: 'mytrove-dev.firebaseapp.com',
    databaseURL: 'https://mytrove-dev.firebaseio.com',
    projectId: 'mytrove-dev',
    storageBucket: 'mytrove-dev-au',
    messagingSenderId: '371449507009'
  },
  paymentKey: 'pk_test_PjIhKOGxkHOoiAzYbjuD6FA2',
  functionsURL: 'https://dev.app.mytrove.co.nz/api',
  // functionsURL: 'http://localhost:5000/mytrove-dev/us-central1',
  brochureURL: 'https://dev.mytrove.co.nz',
  standardBackground: '#f3f0f0',
  portalBackground: '#fff',
  uidAaronStewart: 'INdCcsMxFP',
  uidRossHughson: 'NANANANANA',
  uidSteveJones: 'NANANANANA',
  microsoftAuthConfigurations: {
    PARTNERS: {
      tenant: '261e6108-4f7f-4a41-a34b-e779ddbe1ba1',
    },
    IRD: {
      tenant: '9f11707d-77f5-4d9f-8d81-8fdfba7bcc6c',
    },
    KIWIBANK: {
      tenant: '34833f84-d2f5-476c-8e57-a533a2cb8a0f',
    },
    TEST: {
      tenant: 'common' // Start with 'common' for any account
    }
  }
};
